// @flow

// Effect Managers
import { call } from 'redux-saga/effects'

// Constants
import {
  GET,
} from '../constants'

// Types
import type {
  GetFetchOptionsReturn,
  ComposeGetArgs,
  GetArgs,
  GetResponse,
  Get,
} from '../../types'

// Exports
export default function ({
  getFetchOptions,
  getUrl,
  }: ComposeGetArgs): Get {
  return function *__get ({ path, token, external = false, parse = false }: GetArgs): Generator<*, GetResponse, *> {
    const options: GetFetchOptionsReturn = yield call(getFetchOptions, {
      type: GET,
      token,
    })

    const url: string = getUrl({ path })
    const response: Response = yield call(fetch, url, options)

    if (__DEV__) {
      const clone = yield call([response, response.clone])
      const text = yield call([clone, clone.text])
      console.info(clone)
      console.info(text)
    }
    return response
  }
}
